/**
 * @Author: Nenad Brcic
 * @Date: 31.05.16
 * @Email: neno@neno.ch
 */

import React, { Component, PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import Icon from '../../../shared/Icon';
// import styles from './Location.scss';
import localize from '../../../../localize';
import { getCurrentLanguage } from '../../../../localData';


class Location extends Component {

    static propTypes = {
        object: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            isLocationVisible: false,
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.object !== nextProps.object) {
            this.setState({isLocationVisible: false});
        }
    }

    toggle = () => {
        this.setState({
            isLocationVisible: !this.state.isLocationVisible,
        });
    };

    l = (key) => {
        const str = `${getCurrentLanguage()}.components.ObjectDetail.${key}`;
        return localize(str);
    };

    render() {
        const { object } = this.props;
        const isLocationVisible = this.state.isLocationVisible;
        const ico = isLocationVisible ? "Vitra_Up.svg" : "Vitra_Down.svg";
        const defListClassName = isLocationVisible ? null : 'is-hidden';

        return (
            <div>
                {
                    !!object.ObjFloorplan ? (
                        <aside>
                            <h2 styleName="toggle" onClick={ () => this.toggle() }>
                                <span className="content-box">
                                    { this.l('ObjFloorplan') }
                                    <Icon icon={ ico } />
                                </span>
                            </h2>
                            <div styleName="section-content" className={ defListClassName }>
                                <div className="content-box">
                                    <p styleName="location-meta">
                                        <span styleName="location-number">
                                            {!!object.ObjObjectNumberTxt ? (
                                                `#${object.ObjObjectNumberTxt}`
                                            ) : null}
                                        </span>
                                        <span styleName="location-caption">
                                            {object.ObjFloorplanCaption}
                                        </span>
                                    </p>
                                    <img src={object.ObjFloorplan} styleName="image" />
                                </div>
                            </div>
                        </aside>
                    ) : null
                }
            </div>
        )
    }
}

export default CSSModules(Location);


// WEBPACK FOOTER //
// ./app/components/Object/Detail/Location/Location.jsx